module.exports = __webpack_public_path__ + "static/media/no_results_dark.e6859522.svg";